export var BailleursParticipantSex;
(function (BailleursParticipantSex) {
    BailleursParticipantSex["MALE"] = "M";
    BailleursParticipantSex["FEMALE"] = "Mme";
})(BailleursParticipantSex || (BailleursParticipantSex = {}));
